import { render, staticRenderFns } from "./ZoomGallery.vue?vue&type=template&id=5013cc0b&"
import script from "./ZoomGallery.vue?vue&type=script&lang=js&"
export * from "./ZoomGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports